import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import CastingCommon from '@utils/casting-common';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class Influencers extends React.Component {
  render() {
    let base = this.props.base;
    let targets = this.props.targets;
    
    let workflow = base.workflow;
    
    let influencers = [];
    targets.map((id) => {
      let d = workflow.influencers[id];
      if( d == undefined ) return;
      
      Const.value.workflow.map((w) => { if( w.id == d.progress ) d.order_no = w.order; });
      if( d.order_no == undefined ) d.order_no = 99;
      
      influencers.push(d);
    });
    influencers = Utils.sort(influencers, 'order_no', 'asc');
    
    return (
      <ul className="project-influencers">
        { influencers.map((d, key) => {
          let is_pickup = '';
          //if( this.state.progress != null ) is_pickup = (this.state.progress == d.progress ) ? 'is_pickup' : 'is_pickup_fade';
          
          let progress_status = CastingCommon.getProgressStatus(d.progress, workflow.list, d.is_ng);
          let request_action = CastingCommon.getRequestAction(base, d.insta_user_id);
          
          // DM通知確認
          let is_dm_already_read = false;
          try {
            if( base.dm_already_read[d.insta_user_id][base.project.detail.main_dm_account] != undefined ) is_dm_already_read = true;
          } catch(e) {}
          
          return (
            <OverlayTrigger key={key} placement="top" delayShow={50} overlay={<Tooltip>@{d.insta_id}</Tooltip>}>
              <li className={is_pickup +' color_'+ progress_status.color} onClick={base.event.showInfluencer.bind(this, d.insta_user_id, true, this.props.side_tab)}>
                { (d.thumbnail != null)
                  ? <img src={d.thumbnail} onError={(e)=>{e.target.src="/images/default.jpg"}} />
                  : <img src="/images/default.jpg" />
                }
                <div className="dot" />
                
                { (request_action != null) && <i className={'material-icons info-alert type_'+ request_action}>{( request_action == 'dm' ) ? 'email' : 'info' }</i> }
                {/* (request_action == 'client_check') && <i className="material-icons info-alert">info</i> */}
                
                { (is_dm_already_read == true) && <i className="material-icons dm-already-read">email</i> }
                
                { CastingCommon.getProgressMark(d) }
              </li>
            </OverlayTrigger>
          );
        })}
      </ul>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Influencers;